<template>
  <div class="content">
    <div class="quiz">
      <div class="quiz-left">
        <div class="left-head">{{name}}</div>
        <div class="left-main">
          <div class="quiztype">
            <img src="@img/type@2x.png" alt />
          </div>
          <div class="quiztext" v-if="list[qIndex].qtype == 1">单选</div>
          <div class="quiztext" v-if="list[qIndex].qtype == 2">多选</div>
          <div class="order_num">{{qIndex + 1}}.</div>
          <div class="main" v-html="convert(list[qIndex].title)"></div>
          <div
            class="options"
            v-for="(item,index) in optionList"
            :key="index"
            @click="change(index,item)"
            :class="{selected:item.is_check && queryIndex.indexOf(index) > -1|| queryArr.indexOf(index) > -1,
             right:!isActive&&list[qIndex].is_right == 1&&rightIndex == index && (qtype == 1 || qtype == 2) || rightArr.indexOf(index) > -1 && rightShow && (qtype == 1 || qtype == 2),
             error:(qtype == 1 || qtype == 2)&& !isActive &&list[qIndex].is_right == 0&&errorIndex == index || (qtype == 1 || qtype == 2)&& errArr.indexOf(index)  > -1  == 1,
             }"
          >
            <div class="option-sign">{{optionT[index]}}</div>
            <div
              class="option"
              v-if="list[qIndex].options"
              v-html="item.option"
            ></div>
          </div>
          <div class="my-answer">
            <div class="left">
              我的答案:
              <div
                class="lefts"
              >
                <div
                  class="options"
                  v-for="(zz,cc) in list[qIndex].queryNum "
                  :key="cc"
                  :class="{right:is_right == 1 && qtype ==1,error:qtype == 1 && is_right == 0,selected:qtype>1}"
                >
                  <div class="option-sign">{{optionT[zz]}}</div>
                </div>
              </div>
            </div>
            <div class="middle" >
              <div class="btn" v-if="!nosure && nextShow" @click="next">下一题</div>
              <div class="btn" v-if="nosure" @click="submitAns">提交</div>
            </div>
            <div class="right">
              <div class="collet" @click="collect" v-if="list[qIndex].is_collect == 0">
                <img src="@img/Collection_default@2x.png" alt />
                <div>收藏</div>
              </div>
              <div class="collet" @click="collect" v-if="list[qIndex].is_collect == 1 ">
                <img src="@img/Collection_select@2x.png" alt />
                <div>已收藏</div>
              </div>
              <div class="upreport" @click="addFeedback">
                <img src="@img/wrong@2x.png" alt />
                <div>反馈</div>
              </div>
            </div>
          </div>
          <div class="under" v-if="showUnder == true || list[qIndex].is_right>=0&&sign!==3">
            <div class="right-answer">
              <div class="title">正确答案:</div>
              <div class="sign right" v-show="list[qIndex].qtype == 1">{{list[qIndex].answer}}</div>
              <div class="sign right" v-show="list[qIndex].qtype == 2" v-for="items in list[qIndex].mulAnswer" :key="items">{{items}}</div>
            </div>
            <div class="analyze">
              <div class="title">试题解析:</div>
              <div class="detail" v-html="list[qIndex]&&list[qIndex].analysis"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="quiz-right">
        <div class="right-head">
          <img src="@img/time@2x.png" alt />
          <div class="time">{{hour+':'+min+':'+scend}}</div>
        </div>
        <div class="right-main">
          <div class="card-group">
            <div
              class="answer-card default"
              v-for="(n,ind) in pageList"
              :class="{right:list[n-1].is_right == 1 && qtype == 1,
              error:list[n-1].is_right == 0 && qtype == 1,
              doing:qIndex == n-1 && qtype == 1  || qIndex == n-1 &&qtype >1,
              doings: qtype == 2 && list[n-1].is_right >=0 || qtype == 3 && list[n-1].is_right >=0
              }"
              :key="ind"
              @click="toQuestion(n-1)"
            >{{n}}</div>
          </div>
          <div class="page">
            <a-pagination
              :defaultCurrent="1"
              :size="'small'"
              @change="changePage"
              :defaultPageSize="25"
              :total="len"
            />
          </div>
          <div class="submit" v-if="qclass ==1">
            <a-button class="btn" type="primary" v-if="$route.query.nosu != false" @click="showModal">确认提交</a-button>
            <a-modal
              title="提示"
              v-model="visible"
              @ok="handleOk"
              okText="确认"
              cancelText="取消"
            >{{notdo != 0 ?'还有'+notdo+'道题未答，确认提交吗':'是否确认提交'}}</a-modal>
          </div>
        </div>
      </div>
    </div>
    <div class="shades" v-show="showShades"></div>
    <div class="reply" v-show="showShades">
      <p>{{replyTitle}}：</p>
      <a-textarea class="reply-box" minlength="15" maxlength="101" @input="changeInput()"
       onchange="this.value=this.value.substring(0, 200)"
        onkeydown="this.value=this.value.substring(0, 200)"
         onkeyup="this.value=this.value.substring(0, 200)"
          v-model="message" placeholder="请描述问题，填写问题至少大于15个字符" />
      <div class="fkuishuoming">
        <span>反馈说明：</span>
        <p>1、该意见反馈可以反馈你在做题中遇到的一些问题，或者感觉需要优化的地方，这里反馈的问题只针对软件本身</p>
        <p>2、如果需要反馈软件相关的问题，可拨打客服热线0731-89675413</p>
      </div>    
      <div class="btnzcli">
        <a-button class="reply-btn" block @click="cancel">取消</a-button>
        <a-button class="reply-btn" type="primary" block @click="commitReply(list[qIndex])">提交</a-button>
      </div>
      
    </div>
    <a-alert :message="errmsg" v-if="errshow" class="errshow" type="error" showIcon />
  </div>
</template>
<script>
import { Modal } from "ant-design-vue";
import { mapState, mapMutations } from "vuex";
import { group_sign,getCookie,GetClear,htmlDecode,Format } from '../../utils/tool';
export default {
  data() {
    return {
      showShades: false, //错题反馈
      message:'',
      replyTitle: "错题反馈",
      qtype: -1, //做题类型
      qclass: -1, //是否是查看解析
      errshow: false,
      errmsg: "",
      paper_id: -1, //试题ID
      hour: "00",
      min: "00",
      visible: false,
      notdo: 0,
      scend: "00",
      last_duration: 0, //经过时间
      qIndex: 0, //当前题目索引
      nextClose: false, //是否关闭下一题按钮
      isActive: true,
      name: "",
      qtitle: "",
      grades: true,
      answerCardShow: false,
      question_record: [],
      subflag: true,
      queryXX: [],
      list_id: "",
      list_flag: false,
      nextShow: true,
      last_duration: 0,
      optionList: [],
      rightIndex: -1,
      errorIndex: -1,
      rightSigh: -1,
      errorSigh: -1,
      queryIndex: [],
      permission: true,
      rightShow: false,
      queryArr: [],
      errArr: [],
      rightArr: [],
      nosure: false,
      indexList: [],
      shades: false,
      list: [],
      optionT: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"],
      rightAnswer: "",
      question_ids: [],
      questionIndex: [],
      len: 0,
      pageList: [],
      account_id:Number(getCookie('account_id')),
      student_id: Number(getCookie('studentId')),
      showUnder:false,
      mulAnswer: "",
      chapter_id: "",
      part_id:'',
      is_right: 0,
      page:1,
      pageSize: 9999,
      exam_id:'',
      nosu: false
    };
  },
  computed: mapState(["answerList", "explanList", "record"]),
  watch:{
    list(){
      if (this.$route.query.nosure == true) {
        this.list =  this.answerList
        this.permission = false
        this.showUnder = true
        this.nextShow = true
      }
    
      // if (this.list[this.qIndex].is_right) {
      //   debugger
      //   this.showUnder = true
      // } 
    },
    qIndex: {
      immediate: true, // immediate选项可以开启首次赋值监听
      handler(newVal, oldVal) {
        console.log(newVal, oldVal)
        console.log("触发数组更改")
        if (newVal != oldVal &&this.list[this.qIndex+1].is_right) {
          this.showUnder = true
        }
        console.log(this.showUnder)
      }
      
    }
  },
  created(){
    // this.list = this.answerList
    // this.permission = this.$route.query.nosu ? this.$route.query.nosu : true
  },
  methods: {
    ...mapMutations(["setAnswerList", "setExplanList", "setRecord"]),
    // 错题反馈
    addFeedback() {
      this.showShades = true
    },
    commitReply(item) {
      let that = this
      let params = group_sign({account_id: that.account_id,student_id: that.student_id,question_id: item.id,paper_id:item.paper_id,answer_brief: that.message})
      this.$axios.post(this.$Api.saveErrQuestionFeedback, params).then(
        res => {
          if(res.data.errcode == 0) {
            that.showShades = false
            that.message = ''
          } else {
            that.showShades = false
            that.message = ''
            that.errmsg = res.data.errmsg;
            that.errshow = true;
            let timeErrzz = setTimeout(() => {
              that.errshow = false;
              that.errmsg = "";
              clearTimeout(timeErrzz);
            }, 2000);
          }
        }
      )
    },
    cancel(){
      this.showShades = false
      this.message = ''
    },
    changeInput(){
      if (this.message.length > 100 ) {
        alert('输入字数不能超过100')
      }
    },
    convert (htmlstr) {
      let htmlText = htmlstr
      let str = htmlText.replace(/<(img).*?(\/>|<\/img>)/g, function(a){
        if(a.indexOf('style') < 0 ){
            return a.replace(/<\s*img/, '<img style="max-width:100%;height:auto"');
        }else{
            return a.replace(/style=("|')/, 'style=$1max-width:100%;height:auto')
        }
     });
      return str
    
    },
    changePage(page, pageSize) {
      this.pageList = this.parentPage[page - 1];
    },
    showModal() {
      this.visible = true;
      let notdo = 0;
      this.list.forEach(function(item) {
        if (item.is_right == undefined) {
          notdo = notdo + 1;
        }
      });
      this.notdo = notdo;
    },
    getNowTime() {
        var date = new Date();
        this.year = date.getFullYear();
        this.month = date.getMonth() + 1;
        this.date = date.getDate();
        this.hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        this.minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        this.second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        // this.milliSeconds = date.getMilliseconds();
        var currentTime = this.year+'-'+this.month + '-' + this.date + ' ' + this.hour + ':' + this.minute + ':' + this.second;
        return currentTime;
    },
    handleOk() {
      this.setAnswerList(this.list);
      this.setExplanList(this.list);
      this.setRecord(this.record_id);
      let rightnum = 0;
      this.list.forEach(function(item) {
        if (item.is_right == 1) {
          rightnum++;
        }
      });
      let duration = this.hour + ":" + this.min + ":" + this.scend;
      let total = this.list.length;
      let rate = Math.floor((rightnum / total) * 100);
      rate = rate + "%";
      // let qesrescord = this.question_record;
      if (this.qtype == 3) {
        let question_data = [];
        var d = this.getNowTime()
        this.list.forEach((i) => {
          let a = []
          if (i.qtype == 2 && i.my_answer != undefined) {
            a = [...new Set(i.my_answer.split(','))]
          }
          if (i.my_answer == undefined || i.is_right == undefined) {
            this.errshow = true;
            this.errmsg = '请完成全部做题在提交';
            let timeError = setTimeout(() => {
              this.errmsg = "";
              this.errshow = false;
              clearTimeout(timeError);
            }, 2000);
          } else {
            question_data.push({
              answer:i.qtype == 1 ? i.selected != undefined ? i.selected: '': a != undefined ? a : '',
              is_right: i.is_right != undefined ? i.is_right : '',
              question_id: i.id,
              score: i.score,
              answer_time: d
            });
          }
        });
        var param = group_sign({account_id:this.account_id,student_id: this.student_id,exam_id: this.exam_id,
         paper_id:this.paper_id,course_id: this.course_id,question_data: question_data});
        this.$axios.post(this.$Api.saveStuExamPaperRecord, param).then(
          res => {
            // debugger
            if (res.data.errcode == 0) {
              this.$router.push({
                path: "/page/question/report",
                query: {
                  paper_id: this.paper_id,
                  sign: this.sign,
                  rightnum: rightnum,
                  name: this.name,
                  duration: duration,
                  rate: rate,
                  total: total
                }
              });
            } else {
              this.errshow = true;
              this.errmsg = res.data.errmsg;
              let timeError = setTimeout(() => {
                this.errmsg = "";
                this.errshow = false;
                clearTimeout(timeError);
              }, 2000);
              }
          }
        )
      } else {
        this.$router.push({
          path: "/page/question/report",
          query: {
            paper_id: this.paper_id,
            sign: this.sign,
            rightnum: rightnum,
            name: this.name,
            duration: duration,
            rate: rate,
            total: total,
            course_id :this.course_id,
            chapter_id : this.chapter_id,
            part_id : this.part_id,
          }
        });
      }
      
      
      this.visible = false;
    },
    ToCDB(str) {
      var tmp = "";
      for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) == 12288) {
          tmp += String.fromCharCode(str.charCodeAt(i) - 12256);
          continue;
        }
        if (str.charCodeAt(i) > 65280 && str.charCodeAt(i) < 65375) {
          tmp += String.fromCharCode(str.charCodeAt(i) - 65248);
        } else {
          tmp += String.fromCharCode(str.charCodeAt(i));
        }
      }
      return tmp;
    },
    handOk() {
      this.errshow = false;
    },
    //获取每道试题的ID，从而获取具体数据
    getIntPaper() {
      this.getQuestion();
    },
    //分割题目列表
    menuList(len) {
      this.len = len;
      let arr1 = [];
      let arr2 = [];
      for (let index = 0; index < len; index++) {
        let numb = index + 1;
        arr1.push(numb);
        if (numb % 25 == 0 || numb == len) {
          arr2.push(arr1);
          arr1 = [];
        }
      }
      this.pageList = arr2[0];
      this.parentPage = arr2;
    },
    
    // 获取试题数据
    getQuestion() {
      let paper_id = this.paper_id;
      var param = group_sign({account_id: this.account_id,student_id:this.student_id,paper_id:this.paper_id,page:this.page,pageSize:this.pageSize})
      if (this.qclass == 1) {
        this.$axios.post(this.$Api.apiGetTestPaperQues,param).then(
          res => {
            let data = res.data.result.list;
            let that = this;
            let newList = data;
            this.list = newList;
            this.menuList(newList.length);
            this.list.forEach(function(item, index) {
              item.queryNum = [];
              if (item.qtype == 1) {
                if (item) {
                  let optionList = [];
                  if (item.options) {
                    JSON.parse(item.options).forEach(function(items, index) {
                      // if (typeof (items)!='string') {
                      //   items = items.toString()
                      //   console.log(items)
                      //   return items
                      // }
                      optionList.push({
                        option: typeof (items)!='string' ? items.toString() :htmlDecode(items).replace(/<(img).*?(\/>|<\/img>)/gmi, function(a){
                            if(a.indexOf('style') < 0 ){
                                return a.replace(/<\s*img/, '<img style="max-width:100%;height:auto"');
                            }else{
                                return a.replace(/style=("|')/, 'style=$1max-width:100%;height:auto')
                            }
                        }),
                        optionText: that.optionT[index],
                        is_check: true
                      });
                    });
                    // console.log(optionList)
                    let rightAnswer = that.optionT.findIndex(function(
                      value,
                      index,
                      arr
                    ) {
                      return value == item.options.answers;
                    });
                    item.rightAnswer = rightAnswer;
                    item.optionList = optionList;
                  } else {
                    item.options_rich.opts.forEach(function(item, index) {
                      optionList.push({
                        option: htmlDecode(item),
                        optionText: that.optionT[index],
                        is_check: true
                      });
                    });
                    let rightAnswer = that.optionT.findIndex(function(
                      value,
                      index,
                      arr
                    ) {
                      return value == item.options_rich.answers;
                    });
                    item.rightAnswer = rightAnswer;
                    item.optionList = optionList;
                    
                  }
                }
              } else if (item.qtype == 2) {
                if (item) {
                  
                  var string = item.answer
                  var strings = string.split(",")
                  item.mulAnswer = strings
                  let opList = [];
                  if (item.options) {
                    JSON.parse(item.options).forEach(function(item, index) {
                      opList.push({
                        option:typeof (item)!='string' ? item.toString() : htmlDecode(item).replace(/<(img).*?(\/>|<\/img>)/gmi, function(a){
                            if(a.indexOf('style') < 0 ){
                                return a.replace(/<\s*img/, '<img style="max-width:100%;height:auto"');
                            }else{
                                return a.replace(/style=("|')/, 'style=$1max-width:100%;height:auto')
                            }
                        }),
                        optionText: that.optionT[index],
                        is_check: false
                      });
                    });
                    let arr = item.options.split(",");
                  
                    let arrIndex = [];
                    let ndex = [];
                    arr.forEach(function(item) {
                      arrIndex.push(
                        that.optionT.findIndex(function(value, index, arr) {
                          return value == item;
                        })
                      );
                    });
                   
                    item.rightArr = arrIndex;
                    item.optionList = opList;
                    item.queryArr = [];
                    item.errArr = [];
                  } else {
                    item.options_rich.opts.forEach(function(item, index) {
                      opList.push({
                        option: item,
                        optionText: that.optionT[index],
                        is_check: false
                      });
                    });
                    let arr = item.options_rich.answers.split(",");
                    let array = item.last_answer.split(",") || [
                      item.last_answer
                    ];
                    item.last_answer = arr;
                    let arrIndex = [];
                    let ndex = [];
                    arr.forEach(function(item) {
                      arrIndex.push(
                        that.optionT.findIndex(function(value, index, arr) {
                          return value == item;
                        })
                      );
                    });
                    array.forEach(function(item) {
                      ndex.push(
                        that.optionT.findIndex(function(value, index, arr) {
                          return value == item;
                        })
                      );
                    });
                    item.rightArr = arrIndex;
                    item.optionList = opList;
                    item.queryArr = [];
                    item.errArr = [];
                    array.forEach(function(items, index) {
                      if (arr.indexOf(items) > -1) {
                        item.queryArr.push(ndex[index]);
                      } else {
                        item.errArr.push(ndex[index]);
                        item.queryArr.push(-1);
                      }
                    });
                  }
                }
              }
            });
            this.initData(this.qIndex)
              this.clock(); 
          }
        )
      }
    },
    // 题目收藏
    collect() {
      let that = this
      if (this.list[this.qIndex].is_collect == 0) {
        // this.list[this.qIndex].is_collect = 1;
        var param = group_sign({account_id: this.account_id,student_id:this.student_id,question_id:this.list[this.qIndex].id,collect_state:1})
        this.$axios.post(this.$Api.apiCollectQues,param).then(
          res => {
            if (res.data.errcode == 0) {
             this.list[this.qIndex].is_collect = 1;
            } else if(res.data.errcode == 403) {
                this.errshow = true;
                this.errmsg = res.data.errmsg;
                let timeError = setTimeout(() => {
                  this.errmsg = "";
                  this.errshow = false;
                  clearTimeout(timeError);
                }, 2000);
                let timeErrors = setTimeout(() => {
                  this.$root.Bus.$emit("showLogin")
                  clearTimeout(timeErrors)
                }, 2000)
              } else {
                this.errshow = true;
                this.errmsg = res.data.errmsg;
                let timeError = setTimeout(() => {
                  this.errmsg = "";
                  this.errshow = false;
                  clearTimeout(timeError);
                }, 2000);
              }
          }
        )
      }
      if (this.list[this.qIndex].is_collect == 1) {
        // this.list[this.qIndex].is_collect = 0;
        var params = group_sign({account_id: this.account_id,student_id:this.student_id,question_id:this.list[this.qIndex].id,collect_state:0})
        this.$axios.post(this.$Api.apiCollectQues,params).then(
          res => {
            if (res.data.errcode == 0) {
              if (this.sign== 5) {
                this.list[this.qIndex].is_collect = 0;
                this.getCollectList()
              } else {
                this.list[this.qIndex].is_collect = 0;
              }
            } else if(res.data.errcode == 403) {
                that.errshow = true;
                that.errmsg = res.data.errmsg;
                let timeError = setTimeout(() => {
                  that.errmsg = "";
                  that.errshow = false;
                  clearTimeout(timeError);
                }, 2000);
                let timeErrors = setTimeout(() => {
                  that.$root.Bus.$emit("showLogin")
                  clearTimeout(timeErrors)
                }, 2000)
              } else {
                that.errshow = true;
                that.errmsg = res.data.errmsg;
                let timeError = setTimeout(() => {
                  that.errmsg = "";
                  that.errshow = false;
                  clearTimeout(timeError);
                }, 2000);
              }
          }
        )
      }
    },
    //渲染数据
    initData(index) {
      if (this.qIndex < this.list.length - 1) {
        this.nextClose = false;
        if (this.list[index].qtype == 2 && this.list[index].queryNum.length > 0) {
          this.nextShow = false
          this.nosure = true
        } else {
          this.nextShow = true;
        }
      } else {
        this.nextClose = true;
        this.nextShow = false;
      }
      this.subflag = true;
      this.rightAnswer = "";
      this.rightShow = false;
      let that = this;
      let rights;
      that.list[index].title = htmlDecode(that.list[index].title);
      if (that.list[index].options) {
        rights = that.list[index].options;
        that.list[index].options = that.ToCDB(
          that.list[index].options
        );
      } else {
        rights = that.list[index].options_rich.answers.split(",");
        that.list[index].options_rich.answers = that.ToCDB(
          that.list[index].options_rich.answers
        );
      }
      this.rights = rights;
      let optionList = [];
      this.nosure = false;
      if (that.qtype == 1) {
        switch (that.list[index].qtype) {
          case 1:
            // if (that.indexList[index].is_right > -1) {
              this.rightAnswer = that.list[index].answer;
              this.optionList = that.list[index].optionList;
              this.rightIndex = that.list[index].rightIndex;
              this.errorIndex = that.list[index].errorIndex;
              this.rightSigh =
                that.list[index].rightSigh > -1
                  ? that.list[index].rightSigh
                  : that.list[index].rightAnswer;
              this.errorSigh = that.list[index].errorSigh;
              this.rightArr = [];
              this.errArr = [];
              this.queryArr = [];
              this.rightShow = true;
              this.isActive = false;
            break;
          case 2:
            // if (that.indexList[index].is_right > -1) {
              this.optionList = that.list[index].optionList;
              this.queryArr = that.list[index].queryArr;
              this.rightArr = that.list[index].rightArr;
              this.errArr = that.list[index].errArr;
              this.rightIndex = -1;
              this.errorIndex = -1;
              this.rightSigh = -1;
              this.errorSigh = -1;
              that.rightShow = true;
              if (this.list[index].queryNum.length > 0) {
                if (this.$route.query.nosure == true) {
                  this.nextShow = true
                } else {
                  this.nextShow = false
                }
                this.nosure = true
              } else {
                this.nextShow = true;
              }
            break;
        }
      } else {
        switch (that.list[index].qtype) {
          case 1:
            // if (that.indexList[index].is_right > -1) {
              this.rightAnswer = that.list[index].answer;
              this.optionList = that.list[index].optionList;
              this.rightIndex = that.list[index].rightIndex;
              this.errorIndex = that.list[index].errorIndex;
              this.rightSigh =
                that.list[index].rightSigh > -1
                  ? that.list[index].rightSigh
                  : that.list[index].rightAnswer;
              this.errorSigh = that.list[index].errorSigh;
              this.queryIndex = [];
              this.queryIndex.push(that.list[index].queryIndex);
              this.optionList.forEach(item => {
                item.is_check = true;
              });
              this.rightArr = [];
              this.errArr = [];
              this.queryArr = [];
              this.rightShow = true;
              this.isActive = true;
            break;
          case 2:
            // if (that.indexList[index].is_right > -1) {
              this.optionList = that.list[index].optionList;
              this.queryArr = that.list[index].queryArr;
              for (let i = 0; i < this.queryArr.length; i++) {
                if (this.queryArr[i] < 0) {
                  this.queryArr.splice(i, 1);
                  continue;
                }
                this.optionList[this.queryArr[i]].is_check = true;
                that.list[index].optionList[this.queryArr[i]].is_check = true;
              }
              this.rightArr = that.list[index].rightArr;
              this.errArr = that.list[index].errArr;
              this.rightIndex = -1;
              this.errorIndex = -1;
              this.rightSigh = -1;
              this.errorSigh = -1;
              that.rightShow = true;
              this.isActive = true;
              if (this.list[index].queryNum.length > 0) {
                this.nextShow = false
                this.nosure = true
              } else {
                this.nextShow = true;
              }

            break;
        }
      }
        this.isActive = true;
    },
    // 切换选项
    change(index, item) {
      let that = this;
      if (this.permission) {
        switch (this.qtype) {
          case 1:
            switch (that.list[that.qIndex].qtype) {
              case 1:
                this.showUnder = true
                if (this.isActive == true) {
                  this.isActive = false;
                  that.list[that.qIndex].queryNum.push(index);
                  if (this.rightAnswer === that.optionT[index]) {
                    that.list[that.qIndex].rightIndex = index;
                    that.list[that.qIndex].rightSigh = index;
                    this.rightIndex = index;
                    this.rightSigh = index;
                    that.list[that.qIndex].selected = that.optionT[index];
                    // this.indexList[that.qIndex].is_right = 1;
                    this.question_record.push({
                      is_right: 1, //是否正确:0错误，1正确
                      question_id: that.list[that.qIndex].question_id,
                      last_duration: that.last_duration, //在第N秒提交该题
                      my_answer: that.optionT[index]
                    });
                  } else {
                    that.list[that.qIndex].errorIndex = index;
                    that.list[that.qIndex].errorSigh = index;
                    that.list[that.qIndex].selected = that.optionT[index];
                    this.errorIndex = index;
                    this.errorSigh = index;
                    this.rightSigh = this.rightAnswer;
                    // this.indexList[that.qIndex].is_right = 0;
                    this.question_record.push({
                      is_right: 0, //是否正确:0错误，1正确
                      question_id: that.list[that.qIndex].question_id,
                      last_duration: that.last_duration, //在第N秒提交该题
                      my_answer: that.optionT[index]
                    });
                  }
                }
                that.submitAns()
                break;
              case 2:
                that.nosure = true
                if (this.isActive == true) {
                  if (!item.is_check) {
                    item.is_check = true;
                    that.list[that.qIndex].queryArr.push(index);
                    this.queryArr.push(index);
                    that.list[that.qIndex].queryNum.push(index);
                  } else {
                    item.is_check = false;
                    let sindex = that.list[that.qIndex].queryArr.indexOf(index);
                    let tindex = that.list[that.qIndex].queryNum.indexOf(index);
                    this.queryArr.splice(sindex, 1);
                    that.list[that.qIndex].queryArr.splice(sindex, 1);
                    that.list[that.qIndex].queryNum.splice(tindex, 1);
                  }
                }
                break;
            }
            break;
          case 2:
            //考试
            switch (that.list[that.qIndex].qtype) {
              case 1:
                this.showUnder = true
                that.optionList.forEach(function(items) {
                  items.is_check = false;
                });
                that.list[that.qIndex].rightIndex = -1;
                that.list[that.qIndex].rightSigh = -1;
                that.list[that.qIndex].errorIndex = -1;
                that.list[that.qIndex].errorSigh = -1;
                that.list[that.qIndex].queryIndex = -1;
                item.is_check = true;
                that.queryIndex.push(index);
                that.list[that.qIndex].queryIndex = index;
                that.list[that.qIndex].selected = that.optionT[index];
                that.list[that.qIndex].queryNum.push(index);
                if (this.rightAnswer === that.optionT[index]) {
                  this.question_record.push({
                    is_right: 1, //是否正确:0错误，1正确
                    question_id: that.list[that.qIndex].question_id,
                    last_duration: that.last_duration, //在第N秒提交该题
                    my_answer: that.optionT[index]
                  });
                  that.list[that.qIndex].rightIndex = index;
                  that.list[that.qIndex].rightSigh = index;
                  this.list[that.qIndex].is_right = 1;
                  this.questionIndex.push(that.qIndex);
                } else {
                  this.question_record.push({
                    is_right: 0, //是否正确:0错误，1正确
                    question_id: that.list[that.qIndex].question_id,
                    last_duration: that.last_duration, //在第N秒提交该题
                    my_answer: that.optionT[index]
                  });
                  that.queryIndex.push(index);
                  that.list[that.qIndex].errorIndex = index;
                  that.list[that.qIndex].errorSigh = index;
                  this.list[that.qIndex].is_right = 0;
                  this.questionIndex.push(that.qIndex);
                }
                
                that.submitAns()
                break;
              case 2:
                this.nosure = true
                if (this.isActive == true) {
                  if (!item.is_check) {
                    item.is_check = true;
                    that.list[that.qIndex].queryArr.push(index);
                    that.list[that.qIndex].queryNum.push(index);
                  } else {
                    item.is_check = false;
                    let sindex = that.list[that.qIndex].queryArr.indexOf(index);
                    let tindex = that.list[that.qIndex].queryNum.indexOf(index);
                    that.list[that.qIndex].queryArr.splice(sindex, 1);
                    that.list[that.qIndex].queryNum.splice(tindex, 1);
                  }
                }
                break;
            }
            break;
          case 3:
            switch (that.list[that.qIndex].qtype) {
              case 1:
                this.showUnder = false
                that.optionList.forEach(function(items) {
                  items.is_check = false;
                });
                that.list[that.qIndex].rightIndex = -1;
                that.list[that.qIndex].rightSigh = -1;
                that.list[that.qIndex].errorIndex = -1;
                that.list[that.qIndex].errorSigh = -1;
                let x = that.questionIndex.indexOf(that.qIndex);
                if (x > -1) {
                  that.questionIndex.splice(x, 1);
                  that.question_record.splice(x, 1);
                  that.list[that.qIndex].queryNum.splice(x, 1);
                }
                that.list[that.qIndex].queryIndex = -1;

                  item.is_check = true;
                  that.queryIndex.push(index);
                  that.list[that.qIndex].queryIndex = index;
                  that.list[that.qIndex].selected = that.optionT[index];
                  that.list[that.qIndex].queryNum.push(index);
                  if (this.rightAnswer == index) {
                    this.question_record.push({
                      is_right: 1, //是否正确:0错误，1正确
                      question_id: that.list[that.qIndex].question_id,
                      last_duration: that.last_duration, //在第N秒提交该题
                      my_answer: that.optionT[index]
                    });
                    that.list[that.qIndex].rightIndex = index;
                    that.list[that.qIndex].rightSigh = index;
                    this.indexList[that.qIndex].is_right = 1;
                    this.questionIndex.push(that.qIndex);
                  } else {
                    this.question_record.push({
                      is_right: 0, //是否正确:0错误，1正确
                      question_id: that.list[that.qIndex].question_id,
                      last_duration: that.last_duration, //在第N秒提交该题
                      my_answer: that.optionT[index]
                    });
                    that.queryIndex.push(index);
                    that.list[that.qIndex].errorIndex = index;
                    that.list[that.qIndex].errorSigh = index;
                    this.list[that.qIndex].is_right = 0;
                    this.questionIndex.push(that.qIndex);
                  }
                that.submitAns()
                break;
              case 2:
                this.nosure = true
                if (this.isActive == true) {
                  if (!item.is_check) {
                    item.is_check = true;

                    that.list[that.qIndex].queryArr.push(index);
                    that.list[that.qIndex].queryNum.push(index);
                  } else {
                    item.is_check = false;
                    let sindex = that.list[that.qIndex].queryArr.indexOf(index);
                    let tindex = that.list[that.qIndex].queryNum.indexOf(index);
                    that.list[that.qIndex].queryArr.splice(sindex, 1);
                    that.list[that.qIndex].queryNum.splice(tindex, 1);
                  }
                }

                break;
            }
            break;
        }
      } else {
        return
      }
    },
    toQuestion(index) {
      if (this.qType > 1 && this.list[this.qIndex].qtype == 2) {
        this.nosure = true
        this.submitAns();
      }
      if (index < this.list.length - 1 && this.nextShow == false) {
        this.nextShow = true;
      } else if (index == this.list.length - 1) {
        this.nextShow = false;
      }
      this.qIndex = index;
      if (this.qIndex == index && this.list[this.qIndex].qtype == 2 && this.list[this.qIndex].queryNum.length > 0) {
        this.nosure = true
        this.nextShow = false;
      }
      if (this.$route.query.nosure) {
        this.nextShow = true
        this.nosure = false;
        this.showUnder = true;
        this.nosu = this.$route.query.nosu
      } else {
        if (this.list[this.qIndex].is_right >= 0) {
          this.showUnder = true
        } else {
          this.showUnder = false
        }
        if (this.qtype > 2) {
          this.showUnder = false
        }
      }
      this.initData(index);
        if(this.list[this.qIndex].is_right >= 0) {
        $('.options').css("pointer-events","none")
      } else {
        $('.options').css("pointer-events","auto")
      }
    },
    // 选项单次提交
    submitAns() {
      // console.log(this.list[this.qIndex].optionList)
      if(this.qtype ==1 || this.qtype ==2){this.showUnder = true} else {this.showUnder = false}
      if (this.subflag) {
        this.subflag = false;
        let that = this;
        let my_answer = "";
        let rightarr = [];
        this.queryArr.forEach(function(item, index) {
          if (index == 0) {
            my_answer = that.optionT[item];
          } else {
            my_answer = my_answer + "," + that.optionT[item];
          }
          if (that.rightArr.indexOf(item) > -1) {
            rightarr.push(item);
          } else {
            that.errArr.push(item);
            that.list[that.qIndex].errArr.push(item);
          }
        });
        that.rightShow = true;
        that.list[that.qIndex].my_answer = my_answer;
        this.question_record.push({
          question_id: that.list[that.qIndex].id,
          last_duration: that.last_duration, //在第N秒提交该题
          my_answer: my_answer
        });
        this.isActive = false;
        this.nosure = false;
      }
      if (this.qIndex == this.list.length - 1) {
        this.nextShow = false;
      }
      if (this.qtype == 1 || this.qtype == 2) {
        if (this.$route.query.nosure == true) {
          return
        } else {
          let newli = this.list[this.qIndex]
          let myAnswer =[]
          if (this.list[this.qIndex].qtype == 2 && this.list[this.qIndex].queryNum.length == 1) {
            alert('此题为多选题')
            this.subflag = true
            this.showUnder = false
            this.isActive = true
            return
          } else {
            if (newli.qtype == 1) {
            myAnswer = [...new Set(newli.selected.split(","))]
            } else {
              myAnswer = [...new Set(newli.my_answer.split(","))]
            }
            let newAnswer = [...new Set(newli.answer.split(","))] 
            this.is_right = myAnswer.sort().toString() == newAnswer.sort().toString() ? 1 : 0;
            this.list[this.qIndex].is_right = this.is_right
            var param = group_sign({account_id: this.account_id,student_id:this.student_id,
            paper_id:this.paper_id,question_id:newli.id,my_answer:myAnswer,qtype:newli.qtype,
            chapter_id: this.chapter_id,course_id:this.course_id,is_right: this.is_right,part_id: this.part_id,question_num:this.qIndex})
              this.$axios.post(this.$Api.apiAnswerQues,param).then(
                res => {
                  if (res.data.errcode == 0) {
                    this.nextShow = true
                    if (this.qIndex == this.list.length -1) {
                      this.nextShow = false
                    }
                    return
                  } else if(res.data.errcode == 403) {
                    this.errshow = true;
                    this.errmsg = res.data.errmsg;
                    let timeError = setTimeout(() => {
                      this.errmsg = "";
                      this.errshow = false;
                      clearTimeout(timeError);
                    }, 2000);
                    let timeErrors = setTimeout(() => {
                      this.$root.Bus.$emit("showLogin")
                      clearTimeout(timeErrors)
                    }, 2000)
                  } else {
                    this.errshow = true;
                    this.errmsg = res.data.errmsg;
                    let timeError = setTimeout(() => {
                      this.errmsg = "";
                      this.errshow = false;
                      clearTimeout(timeError);
                    }, 2000);
                  }
                }
              )
            }
        }
      } else if (this.qtype == 3) {
        if (this.$route.query.nosure == true) {
          return
        } else {
          let newlis = this.list[this.qIndex]
          let myAnswers =[]
          if (newlis.qtype == 1) {
            myAnswers = [...new Set(newlis.selected.split(","))]
          } else {
            myAnswers = [...new Set(newlis.my_answer.split(","))]
          }
          let newAnswers = [...new Set(newlis.answer.split(","))] 
          this.is_right = myAnswers.sort().toString() == newAnswers.sort().toString() ? 1 : 0;
          this.list[this.qIndex].is_right = this.is_right
          if (this.qIndex == this.list.length -1) {
            this.nextShow = false
          }
        }
      }
    },
    next() {
      if (!this.nextClose) {
        if (this.qtype > 1 && this.list[this.qIndex].qtype == 2) {
          this.submitAns();
        }
        this.qIndex = this.qIndex + 1;
        this.initData(this.qIndex);
        if (this.qIndex == this.list.length - 1) {
          this.nextShow = false;
        }
      }
      if (this.$route.query.nosure) {
        this.nextShow = true
        this.nosure = false;
        this.showUnder = true;
        this.nosu = this.$route.query.nosu
      } else {
        // if (this.list[this.qIndex].is_right) {
        //   this.showUnder = true
        // } else {
          this.showUnder =false
        // }
      }
    },
    clock() {
      if (this.qclass == 1) {
        let that = this;
        let timer = setInterval(function() {
          that.last_duration = that.last_duration + 1;
          let min = Math.floor(that.last_duration / 60);
          let scend = that.last_duration % 60;
          let hour = Math.floor(min / 60);
          if (hour < 10) {
            that.hour = "0" + hour;
          } else {
            that.hour = hour;
          }
          if (min == 60) {
            min = 0;
          }
          if (min < 10) {
            that.min = "0" + min;
          } else {
            that.min = min;
          }
          if (scend < 10) {
            that.scend = "0" + scend;
          } else {
            that.scend = scend;
          }
        }, 1000);
        if (this.$route.query.nosure == true) {
          clearInterval(timer)
        }
      }
    },
    // 错题
    getErrList(id) {
      var param = group_sign({account_id: this.account_id,paper_id:id,student_id: this.student_id})
      this.$axios.post(this.$Api.getErrorQuestion,param).then(
        res => {
          let data = res.data.result.list;
            let that = this;
            let newList = data;
            this.list = newList;
            for(let i in newList) {
              newList[i].is_collect = 0;
            }
            this.menuList(newList.length);
            this.list.forEach(function(item, index) {
              item.queryNum = [];
              if (item.qtype == 1) {
                if (item) {
                  let optionList = [];
                  if (item.options) {
                    JSON.parse(item.options).forEach(function(items, index) {
                      optionList.push({
                        option:typeof (items)!='string' ? items.toString() : htmlDecode(items).replace(/<(img).*?(\/>|<\/img>)/g, function(a){
                                if(a.indexOf('style') < 0 ){
                                    return a.replace(/<\s*img/, '<img style="max-width:100%;height:auto"');
                                }else{
                                    return a.replace(/style=("|')/, 'style=$1max-width:100%;height:auto')
                                }
                            }),
                        optionText: that.optionT[index],
                        is_check: true
                      });
                    });
                    let rightAnswer = that.optionT.findIndex(function(
                      value,
                      index,
                      arr
                    ) {
                      return value == item.options.answers;
                    });
                    item.rightAnswer = rightAnswer;
                    item.optionList = optionList;
                  } else {
                    item.options_rich.opts.forEach(function(item, index) {
                      optionList.push({
                        option: htmlDecode(item),
                        optionText: that.optionT[index],
                        is_check: true
                      });
                    });
                    let rightAnswer = that.optionT.findIndex(function(
                      value,
                      index,
                      arr
                    ) {
                      return value == item.options_rich.answers;
                    });
                    item.rightAnswer = rightAnswer;
                    item.optionList = optionList;
                  }
                }
              } else if (item.qtype == 2) {
                if (item) {
                  var string = item.answer
                  var strings = string.split(",")
                  item.mulAnswer = strings
                  let opList = [];
                  if (item.options) {
                    JSON.parse(item.options).forEach(function(item, index) {
                      opList.push({
                        option:typeof (item)!='string' ? item.toString() : htmlDecode(item).replace(/<(img).*?(\/>|<\/img>)/g, function(a){
                                if(a.indexOf('style') < 0 ){
                                    return a.replace(/<\s*img/, '<img style="max-width:100%;height:auto"');
                                }else{
                                    return a.replace(/style=("|')/, 'style=$1max-width:100%;height:auto')
                                }
                            }),
                        optionText: that.optionT[index],
                        is_check: false
                      });
                    });
                    let arr = item.options.split(",");
                    let arrIndex = [];
                    let ndex = [];
                    arr.forEach(function(item) {
                      arrIndex.push(
                        that.optionT.findIndex(function(value, index, arr) {
                          return value == item;
                        })
                      );
                    });
                    item.rightArr = arrIndex;
                    item.optionList = opList;
                    item.queryArr = [];
                    item.errArr = [];
                  } else {
                    item.options_rich.opts.forEach(function(item, index) {
                      opList.push({
                        option: item,
                        optionText: that.optionT[index],
                        is_check: false
                      });
                    });
                    let arr = item.options_rich.answers.split(",");
                    let array = item.last_answer.split(",") || [
                      item.last_answer
                    ];
                    item.last_answer = arr;
                    let arrIndex = [];
                    let ndex = [];
                    arr.forEach(function(item) {
                      arrIndex.push(
                        that.optionT.findIndex(function(value, index, arr) {
                          return value == item;
                        })
                      );
                    });
                    array.forEach(function(item) {
                      ndex.push(
                        that.optionT.findIndex(function(value, index, arr) {
                          return value == item;
                        })
                      );
                    });
                    item.rightArr = arrIndex;
                    item.optionList = opList;
                    item.queryArr = [];
                    item.errArr = [];
                    array.forEach(function(items, index) {
                      if (arr.indexOf(items) > -1) {
                        item.queryArr.push(ndex[index]);
                      } else {
                        item.errArr.push(ndex[index]);
                        item.queryArr.push(-1);
                      }
                    });
                  }
                }
              }
            });
            this.initData(this.qIndex)
              this.clock(); 
        }
      )
    },
    // 试题收藏
    getCollectList() {
      var param = group_sign({account_id: this.account_id,student_id:this.student_id,pageSize:9999})
      this.$axios.post(this.$Api.apiGetCollectQuesList,param).then(
        res => {
          if (res.data.errcode == 0) {
            let data = res.data.result.list;
            if (data == '') {
              let times = setTimeout(() => {
                alert('暂无收藏试题')
                this.$router.push({
                  path: "/page/question"
                });
                clearTimeout(times);
              }, 2000)
            }
            let that = this
            let newList = data;
            this.list = newList;
            this.menuList(newList.length);
            this.list.forEach(function(item, index) {
              item.queryNum = [];
              if (item.qtype == 1) {
                if (item) {
                  let optionList = [];
                  if (item.options) {
                    JSON.parse(item.options).forEach(function(items, index) {
                      optionList.push({
                        option:typeof (items)!='string' ? items.toString() : htmlDecode(items).replace(/<(img).*?(\/>|<\/img>)/g, function(a){
                              if(a.indexOf('style') < 0 ){
                                  return a.replace(/<\s*img/, '<img style="max-width:100%;height:auto"');
                              }else{
                                  return a.replace(/style=("|')/, 'style=$1max-width:100%;height:auto')
                              }
                          }),
                        optionText: that.optionT[index],
                        is_check: true
                      });
                    });
                    let rightAnswer = that.optionT.findIndex(function(
                      value,
                      index,
                      arr
                    ) {
                      return value == item.options.answers;
                    });
                    item.rightAnswer = rightAnswer;
                    item.optionList = optionList;
                  } else {
                    item.options_rich.opts.forEach(function(item, index) {
                      optionList.push({
                        option:typeof (item)!='string' ? item.toString() : htmlDecode(item).replace(/<(img).*?(\/>|<\/img>)/g, function(a){
                                if(a.indexOf('style') < 0 ){
                                    return a.replace(/<\s*img/, '<img style="max-width:100%;height:auto"');
                                }else{
                                    return a.replace(/style=("|')/, 'style=$1max-width:100%;height:auto')
                                }
                            }),
                        optionText: that.optionT[index],
                        is_check: true
                      });
                    });
                    let rightAnswer = that.optionT.findIndex(function(
                      value,
                      index,
                      arr
                    ) {
                      return value == item.options_rich.answers;
                    });
                    item.rightAnswer = rightAnswer;
                    item.optionList = optionList;
                  }
                }
              } else if (item.qtype == 2) {
                if (item) {
                  var string = item.answer
                  var strings = string.split(",")
                  item.mulAnswer = strings
                  let opList = [];
                  if (item.options) {
                    JSON.parse(item.options).forEach(function(item, index) {
                      opList.push({
                        option: typeof (item)!='string' ? item.toString() : htmlDecode(item).replace(/<(img).*?(\/>|<\/img>)/g, function(a){
                              if(a.indexOf('style') < 0 ){
                                  return a.replace(/<\s*img/, '<img style="max-width:100%;height:auto"');
                              }else{
                                  return a.replace(/style=("|')/, 'style=$1max-width:100%;height:auto')
                              }
                          }),
                        optionText: that.optionT[index],
                        is_check: false
                      });
                    });
                    let arr = item.options.split(",");
                    let arrIndex = [];
                    let ndex = [];
                    arr.forEach(function(item) {
                      arrIndex.push(
                        that.optionT.findIndex(function(value, index, arr) {
                          return value == item;
                        })
                      );
                    });
                    item.rightArr = arrIndex;
                    item.optionList = opList;
                    item.queryArr = [];
                    item.errArr = [];
                  } else {
                    item.options_rich.opts.forEach(function(item, index) {
                      opList.push({
                        option: item,
                        optionText: that.optionT[index],
                        is_check: false
                      });
                    });
                    let arr = item.options_rich.answers.split(",");
                    let array = item.last_answer.split(",") || [
                      item.last_answer
                    ];
                    item.last_answer = arr;
                    let arrIndex = [];
                    let ndex = [];
                    arr.forEach(function(item) {
                      arrIndex.push(
                        that.optionT.findIndex(function(value, index, arr) {
                          return value == item;
                        })
                      );
                    });
                    array.forEach(function(item) {
                      ndex.push(
                        that.optionT.findIndex(function(value, index, arr) {
                          return value == item;
                        })
                      );
                    });
                    item.rightArr = arrIndex;
                    item.optionList = opList;
                    item.queryArr = [];
                    item.errArr = [];
                    array.forEach(function(items, index) {
                      if (arr.indexOf(items) > -1) {
                        item.queryArr.push(ndex[index]);
                      } else {
                        item.errArr.push(ndex[index]);
                        item.queryArr.push(-1);
                      }
                    });
                  }
                }
              }
            });
            this.initData(this.qIndex)
            this.clock();
          } else if(res.data.errcode == 403) {
            this.errshow = true;
            this.errmsg = res.data.errmsg;
            let timeError = setTimeout(() => {
              this.errmsg = "";
              this.errshow = false;
              clearTimeout(timeError);
            }, 2000);
            let timeErrors = setTimeout(() => {
              this.$root.Bus.$emit("showLogin")
              clearTimeout(timeErrors)
            }, 2000)
          } else {
            this.errshow = true;
            this.errmsg = res.data.errmsg;
            let timeError = setTimeout(() => {
              this.errmsg = "";
              this.errshow = false;
              clearTimeout(timeError);
            }, 2000);
          }
           
        }
      )
    },
    // 每日一练
    getList(id) {
      let that = this
      var param = group_sign({account_id: this.account_id,category_id:id})
      this.$axios.post(this.$Api.apiDailyPractice,param).then(
        res => {
          if (res.data.errcode == 0) {
            let data = res.data.result.list;
            let that = this;
            let newList = data;
            for(let i in newList) {
              newList[i].is_collect = 0;
            }
            this.list = newList;
            this.menuList(newList.length);
            this.list.forEach(function(item, index) {
              item.queryNum = [];
              if (item.qtype == 1) {
                if (item) {
                  let optionList = [];
                  if (item.options) {
                    JSON.parse(item.options).forEach(function(items, index) {
                      optionList.push({
                        option:typeof (items)!='string' ? items.toString() : htmlDecode(items).replace(/<(img).*?(\/>|<\/img>)/g, function(a){
                                  if(a.indexOf('style') < 0 ){
                                      return a.replace(/<\s*img/, '<img style="max-width:100%;height:auto"');
                                  }else{
                                      return a.replace(/style=("|')/, 'style=$1max-width:100%;height:auto')
                                  }
                              }),
                        optionText: that.optionT[index],
                        is_check: true
                      });
                      // console.log(optionList)
                    });
                    let rightAnswer = that.optionT.findIndex(function(
                      value,
                      index,
                      arr
                    ) {
                      return value == item.options.answers;
                    });
                    item.rightAnswer = rightAnswer;
                    item.optionList = optionList;
                  } else {
                    item.options_rich.opts.forEach(function(item, index) {
                      optionList.push({
                        option:typeof (item)!='string' ? item.toString() : htmlDecode(item).replace(/<(img).*?(\/>|<\/img>)/g, function(a){
                              if(a.indexOf('style') < 0 ){
                                  return a.replace(/<\s*img/, '<img style="max-width:100%;height:auto"');
                              }else{
                                  return a.replace(/style=("|')/, 'style=$1max-width:100%;height:auto')
                              }
                          }),
                        optionText: that.optionT[index],
                        is_check: true
                      });
                    });
                    let rightAnswer = that.optionT.findIndex(function(
                      value,
                      index,
                      arr
                    ) {
                      return value == item.options_rich.answers;
                    });
                    item.rightAnswer = rightAnswer;
                    item.optionList = optionList;
                  }
                }
              } else if (item.qtype == 2) {
                if (item) {
                  var string = item.answer
                  var strings = string.split(",")
                  item.mulAnswer = strings
                  let opList = [];
                  if (item.options) {
                    JSON.parse(item.options).forEach(function(item, index) {
                      opList.push({
                        option: typeof (item)!='string' ? item.toString() : htmlDecode(item).replace(/<(img).*?(\/>|<\/img>)/g, function(a){
                              if(a.indexOf('style') < 0 ){
                                  return a.replace(/<\s*img/, '<img style="max-width:100%;height:auto"');
                              }else{
                                  return a.replace(/style=("|')/, 'style=$1max-width:100%;height:auto')
                              }
                          }),
                        optionText: that.optionT[index],
                        is_check: false
                      });
                    });
                    let arr = item.options.split(",");
                    let arrIndex = [];
                    let ndex = [];
                    arr.forEach(function(item) {
                      arrIndex.push(
                        that.optionT.findIndex(function(value, index, arr) {
                          return value == item;
                        })
                      );
                    });
                    item.rightArr = arrIndex;
                    item.optionList = opList;
                    item.queryArr = [];
                    item.errArr = [];
                  } else {
                    item.options_rich.opts.forEach(function(item, index) {
                      opList.push({
                        option: item,
                        optionText: that.optionT[index],
                        is_check: false
                      });
                    });
                    let arr = item.options_rich.answers.split(",");
                    let array = item.last_answer.split(",") || [
                      item.last_answer
                    ];
                    item.last_answer = arr;
                    let arrIndex = [];
                    let ndex = [];
                    arr.forEach(function(item) {
                      arrIndex.push(
                        that.optionT.findIndex(function(value, index, arr) {
                          return value == item;
                        })
                      );
                    });
                    array.forEach(function(item) {
                      ndex.push(
                        that.optionT.findIndex(function(value, index, arr) {
                          return value == item;
                        })
                      );
                    });
                    item.rightArr = arrIndex;
                    item.optionList = opList;
                    item.queryArr = [];
                    item.errArr = [];
                    array.forEach(function(items, index) {
                      if (arr.indexOf(items) > -1) {
                        item.queryArr.push(ndex[index]);
                      } else {
                        item.errArr.push(ndex[index]);
                        item.queryArr.push(-1);
                      }
                    });
                  }
                }
              }
            });
            this.initData(this.qIndex)
              this.clock(); 
          } else if(res.data.errcode == 403) {
              that.errshow = true;
              that.errmsg = res.data.errmsg;
              let timeErrorss = setTimeout(() => {
                that.errmsg = "";
                that.errshow = false;
                clearTimeout(timeErrorss);
              }, 2000);
              let timeErrors = setTimeout(() => {
                that.$root.Bus.$emit("showLogin")
                clearTimeout(timeErrors)
              }, 2000)
            } else {
              that.errshow = true;
              that.errmsg = res.data.errmsg;
              let timeError = setTimeout(() => {
                that.errmsg = "";
                that.errshow = false;
                clearTimeout(timeError);
              }, 2000);
            }
          
        }
      )
    }
  },
  beforeMount() {
    switch (this.$route.query.sign) {
      case 0: //普通练习
        this.qtype = this.$route.query.qtype;
        this.qclass = this.$route.query.paperclass;
        this.paper_id = parseInt(this.$route.query.id);
        this.name = this.$route.query.name;
        this.course_id = this.$route.query.course_id;
        this.chapter_id = this.$route.query.chapterId
        this.part_id = this.$route.query.partId;
        this.nosure = this.$route.query.nosure;
        this.showUnder = this.$route.query.nosure;
        this.getIntPaper();
        break;
      case 1:  //每日一练
        this.qtype = this.$route.query.qtype;
        this.qclass = this.$route.query.paperclass;
        this.paper_id = parseInt(this.$route.query.id);
        this.name = this.$route.query.name;
        this.showUnder = this.$route.query.nosure
        this.chapter_id = 0;
        this.part_id = 0;
        this.course_id = 0;
        this.getList(this.paper_id);
        break;
      case 2:  //真题练习
        this.qtype = this.$route.query.qtype;
        this.qclass = this.$route.query.paperclass;
        this.paper_id = parseInt(this.$route.query.id);
        this.name = this.$route.query.name;
        this.showUnder = this.$route.query.nosure
        this.chapter_id = 0;
        this.part_id = 0;
        this.course_id = 0;
        this.getIntPaper();
        break;
      case 3: //模拟考场
        this.qtype = this.$route.query.qtype;
        this.qclass = this.$route.query.paperclass;
        this.course_id = this.$route.query.course_id;
        this.paper_id = parseInt(this.$route.query.id);
        this.name = this.$route.query.name;
        this.showUnder = this.$route.query.nosure;
        this.exam_id = this.$route.query.exam_id
        this.getIntPaper();
        break;
      case 4: //错题本
        this.qtype = this.$route.query.qtype;
        this.qclass = this.$route.query.paperclass;
        this.paper_id = parseInt(this.$route.query.id);
        this.name = this.$route.query.name;
        this.showUnder = this.$route.query.nosure
        this.course_id = this.$route.query.course_id;
        this.chapter_id = this.$route.query.chapterId
        this.part_id = this.$route.query.partId;
        this.getErrList(this.paper_id);
        break;
      case 5: //收藏试题
        this.qtype = this.$route.query.qtype;
        this.qclass = this.$route.query.paperclass;
        this.paper_id = parseInt(this.$route.query.id);
        this.name = this.$route.query.name;
        this.showUnder = this.$route.query.nosure
        this.chapter_id = 0;
        this.part_id = 0;
        this.course_id = 0;
        this.getCollectList(this.paper_id);
        break;
      case 6:
        this.qtype = this.$route.query.qtype;
        this.qclass = this.$route.query.paperclass;
        this.paper_id = parseInt(this.$route.query.id);
        this.name = this.$route.query.name;
        this.showUnder = this.$route.query.nosure
        this.course_id = this.$route.query.course_id;
        this.chapter_id = this.$route.query.chapterId
        this.part_id = this.$route.query.partId;
        this.getIntPaper();
        break;
    }
    this.sign = this.$route.query.sign;
    this.nosu = this.$route.query.nosu
  }
};
</script>
<style lang="less" scoped>
@import url('../../assets/less/quiz.less');
</style>
